// Điều khoản sử dụng ShopTrack — trang công khai, link từ Đăng ký / Đăng nhập. Văn bản do pháp chế soạn:
// src/content/legal/terms.md. Mục đánh số 1–22 vì văn bản dẫn chiếu "Mục 5.5", "Mục 15.4", "Mục 22"…

import termsMd from '@/content/legal/terms.md?raw'
import { LegalDocumentPage } from '@/components/legal/LegalDocumentPage'
import { parseLegalDoc } from '@/lib/legalDoc'

const DOC = parseLegalDoc(termsMd, { numberSections: true, idPrefix: 't' })

export default function TermsPage() {
  return (
    <LegalDocumentPage
      doc={DOC}
      back={{ to: '/signup', label: 'Quay lại Đăng ký' }}
      related={{ to: '/privacy', label: 'Chính sách quyền riêng tư' }}
    />
  )
}
